import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const Input = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <input
            ref={ref}
            className={twMerge(clsx(
                "w-full bg-transparent border border-white/10 text-stone-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-blue-400/50 focus:bg-white/5 focus:shadow-[0_0_15px_rgba(59,130,246,0.2)] hover:border-white/20 transition-all backdrop-blur-sm placeholder:text-stone-600",
                className
            ))}
            {...props}
        />
    );
});

Input.displayName = 'Input';
